import { Button } from "react-bootstrap";
import { DocumentListViewToolbar } from "./DocumentListViewToolbar";
import { ListViewToolbarButton } from "./ListViewToolbarButton";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { IListViewCreateDependedDocumentAction } from "../IListViewCreateDependedDocumentAction";
import { Tooltip } from "devextreme-react";
import ThreeDots from "../../../assets/img/svg/ThreeDots";
import { IListViewCreateMoreActions } from "../IListViewCreateMoreAction";

interface IProps {
  children?: React.ReactNode;
  handleOpenHierarchy?: () => void;
  handleOpenMoreActions?: () => void;
  handleComponentRefresh?: () => void;
  createMoreActions?: IListViewCreateMoreActions[];
  selectedItem?: boolean | undefined;
}

export const ListviewToolbarMoreActions = ({
  // children,
  createMoreActions,
  handleComponentRefresh,
  handleOpenMoreActions,
  handleOpenHierarchy,
  selectedItem
}: IProps) => {
  const { t } = useTranslation();
  const [createMoreActionsVisible, setCreateMoreActionsVisible] = useState<boolean>(false);
  const uniqueId = uuidv4();
  const handleCreateDocumentActionPopupButtonClick = () => {
    setCreateMoreActionsVisible(!createMoreActionsVisible);
  };
  const openHierarchy = () => {
    if (handleOpenHierarchy) {
      handleOpenHierarchy();
      setCreateMoreActionsVisible(false);
    }
  };
  
  return (
    <>
        <Button disabled={!selectedItem} id={`moreAction_${uniqueId}`} size={"sm"} variant="" className="btn btn-light ms-2 me-2"  onClick={handleCreateDocumentActionPopupButtonClick}>
          <ThreeDots />
        </Button>
        <Tooltip
          target={`#moreAction_${uniqueId}`}
          position="bottom"
          visible={createMoreActionsVisible}
          onHidden={() => {
            setCreateMoreActionsVisible(false);
          }}
          hideOnOutsideClick={true}
        >
          <b className="d-flex flex-column">
            {createMoreActions?.map((action, index) => (
              <div className={"text-start my-2"} key={index}>
                <Button size={"sm"} variant="" className="btn btn-light w-100"  onClick={handleOpenMoreActions}>
                  {action.title}
                </Button>
              </div>
            ))}
            <Button
              size={"sm"}
              variant=""
              className="btn btn-light mb-2 me-2 w-100"
              // disabled={!selectedItem}
             onClick={openHierarchy}
            >
              <i className="fa-solid fa-sitemap me-2"></i>
              {t("Hierarchy")}
            </Button>
            <Button size={"sm"} variant="" className="btn btn-light w-100" onClick={handleComponentRefresh}>
              <i className="fa-solid fa-rotate-right me-2"></i>
              {t("Refresh")}
            </Button>
          </b>
        </Tooltip>
      </>
  );
};
